import React from 'react';

export const PropertyTypePropertySubType = ({
  PropertyTypeInPropertySubType,
  getPropertySubTypeId,
  handlePropertySubType,
}) => {
  return (
    <div className="mt-4">
      {PropertyTypeInPropertySubType && (
        <label className="h5 mb-2">Property Sub Type: </label>
      )}
      <div className="form-group d-flex flex-wrap align-items-stretch">
        {PropertyTypeInPropertySubType &&
          PropertyTypeInPropertySubType &&
          React.Children.toArray(
            PropertyTypeInPropertySubType?.map(
              (propertySubtype, index) => (
                <>
                  <div
                    key={index}
                    className={`button-belair col-6 mb-0 mt-0 ${
                      // eslint-disable-next-line eqeqeq
                      getPropertySubTypeId == propertySubtype?.id
                        ? 'blend'
                        : ''
                    }`}
                    onClick={handlePropertySubType}
                    data-propertysubtype={propertySubtype?.id}
                  >
                    {propertySubtype?.text}
                  </div>
                </>
              ),
            ),
          )}
      </div>
    </div>
  );
};
